export const TESTIDS = {
  // Home
  homeHero: 'home-hero',
  homeAdminLink: 'home-admin-link',

  // Admin login
  adminLoginForm: 'admin-login-form',
  adminLoginUsername: 'admin-login-username',
  adminLoginPassword: 'admin-login-password',
  adminLoginSubmit: 'admin-login-submit',
  adminLoginError: 'admin-login-error',

  // Admin page
  adminPage: 'admin-page',
  adminLogout: 'admin-logout',
  testModeBanner: 'test-mode-banner',
  sendBatchForm: 'send-batch-form',
  sendBatchServiceContract: 'send-batch-service-contract',
  sendBatchServiceInvoice: 'send-batch-service-invoice',
  sendBatchServiceInsurance: 'send-batch-service-insurance',
  sendBatchServiceHealthSafety: 'send-batch-service-health-safety',
  sendBatchContractTypeSmart: 'send-batch-contract-type-smart',
  sendBatchContractTypeUnique: 'send-batch-contract-type-unique',
  sendBatchEmails: 'send-batch-emails',
  sendBatchSubmit: 'send-batch-submit',
  sendBatchSuccess: 'send-batch-success',
  sendBatchError: 'send-batch-error',
  batchSummary: 'batch-summary',
  contractList: 'contract-list',
  contractRow: 'contract-row',
  contractRowStatus: 'contract-row-status',
  contractRowDownload: 'contract-row-download',
  contractRowCopyLink: 'contract-row-copy-link',
  contractRefresh: 'contract-refresh',
  contractExportCsv: 'contract-export-csv',
  contractRowDelete: 'contract-row-delete',
  contractRowResend: 'contract-row-resend',
  deleteConfirmDialog: 'delete-confirm-dialog',
  deleteConfirmBtn: 'delete-confirm-btn',
  deleteCancelBtn: 'delete-cancel-btn',
  // Admin tabs
  adminTabSend: 'admin-tab-send',
  adminTabLibrary: 'admin-tab-library',
  // Send form — dynamic documents
  docShowAvailableBtn: 'doc-show-available-btn',
  docAvailableList: 'doc-available-list',
  docCheckbox: 'doc-checkbox',
  // Document Library management
  docLibrary: 'doc-library',
  docUploadForm: 'doc-upload-form',
  docUploadName: 'doc-upload-name',
  docUploadDescription: 'doc-upload-description',
  docUploadFile: 'doc-upload-file',
  docUploadSubmit: 'doc-upload-submit',
  docLibraryList: 'doc-library-list',
  docRow: 'doc-row',
  docRowRename: 'doc-row-rename',
  docRowRenameInput: 'doc-row-rename-input',
  docRowRenameSave: 'doc-row-rename-save',
  docRowActiveToggle: 'doc-row-active-toggle',
  docRowDelete: 'doc-row-delete',
  docDeleteConfirmDialog: 'doc-delete-confirm-dialog',
  docDeleteConfirmBtn: 'doc-delete-confirm-btn',
  docDeleteCancelBtn: 'doc-delete-cancel-btn',
  // Generic document signing
  documentSignerForm: 'document-signer-form',
  docSignName: 'doc-sign-name',
  docSignCompany: 'doc-sign-company',
  docSignSubmit: 'doc-sign-submit',
  signingDownloadSigned: 'signing-download-signed',

  // Signing page
  signingPage: 'signing-page',
  signingErrorState: 'signing-error-state',
  signingPdfFrame: 'signing-pdf-frame',
  signingDownloadOriginal: 'signing-download-original',
  signingForm: 'signing-form',
  signingContractorCompany: 'signing-contractor-company',
  signingContractorName: 'signing-contractor-name',
  signingContractDate: 'signing-contract-date',
  signingPrintedName: 'signing-printed-name',
  signingCapacity: 'signing-capacity',
  signingSignedDate: 'signing-signed-date',
  signingPad: 'signing-pad',
  signingPadClear: 'signing-pad-clear',
  signingAgree: 'signing-agree',
  signingSubmit: 'signing-submit',
  signingSuccess: 'signing-success',
  signingErrorMsg: 'signing-error-msg',

  // Service response page (invoice / insurance)
  serviceResponseForm: 'service-response-form',
  serviceWorkerName: 'service-worker-name',
  serviceWorkerCompany: 'service-worker-company',
  serviceResponseYes: 'service-response-yes',
  serviceResponseNo: 'service-response-no',
  serviceResponseSubmit: 'service-response-submit',
  serviceResponseDeclineConfirm: 'service-response-decline-confirm',
  serviceResponseDeclineCancel: 'service-response-decline-cancel',
  serviceResponseDeclineDialog: 'service-response-decline-dialog',
  serviceResponseDeclined: 'service-response-declined',

  // Health & Safety form
  hsRulesList: 'hs-rules-list',
  hsReadCheckbox: 'hs-read-checkbox',
  hsCompliantBtn: 'hs-compliant-btn',
  hsWorkerName: 'hs-worker-name',
  hsWorkerCompany: 'hs-worker-company',
  hsToolboxList: 'hs-toolbox-list',
  hsToolboxCard: 'hs-toolbox-card',
  hsToolboxMarkBtn: 'hs-toolbox-mark-btn',
  hsToolboxCounter: 'hs-toolbox-counter',
  hsToolboxContinue: 'hs-toolbox-continue',
};
